import React from 'react';
import { classes } from './ServiceInfo.st.css';
import { ViewModel } from '../../../../controller/viewModel/viewModel';
import { ServiceDescription } from './ServiceDescription/ServiceDescription';
import { ServiceTitle } from './ServiceTitle/ServiceTitle';

export const ServiceInfo: React.FC<{
  service: ViewModel['bodyViewModel']['services'][number];
}> = ({ service }) => {
  return (
    <div data-id={service.id} role="group" className={classes.root}>
      <ServiceTitle title={service.name} />

      {service.description && (
        <ServiceDescription description={service.description} />
      )}
    </div>
  );
};
